import { Box, Stack, Typography } from "@mui/material";

export const ScmConfigsEmpty = () => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      gap={3}
      sx={{ py: 6 }}
    >
      <Box
        component="img"
        src="./img/empty.svg"
        alt="Nenhuma configuração encontrada"
        sx={{ width: 220, maxWidth: "80%" }}
      />
      <Stack gap={0} alignItems="center">
        <Typography variant="h6" fontWeight="bold">
          Nenhuma configuração encontrada
        </Typography>
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          gutterBottom
        >
          Não há empresas com parâmetros de projeção SCM configurados.
        </Typography>
      </Stack>
    </Stack>
  );
};
